// This icon file is generated automatically.
var PFrownOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M3.5 5.58a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm5.5 0a.75.75 0 101.5 0 .75.75 0 00-1.5 0zM7 0a7 7 0 100 14A7 7 0 007 0zm4.1 11.1a5.81 5.81 0 11-8.22-8.2 5.81 5.81 0 018.23 8.2zM7 7.34A2.5 2.5 0 004.5 9.7c0 .07.05.13.13.13h.75c.06 0 .12-.05.12-.12a1.5 1.5 0 013 0c0 .07.06.12.12.12h.76c.07 0 .12-.06.12-.13A2.5 2.5 0 007 7.33z", "fill-rule": "nonzero" } }] }, "name": "p-frown", "theme": "outlined" };
export default PFrownOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PFrownOutlined.js
// module id = 3435
// module chunks = 0